import React from 'react';
import Loadable from 'react-loadable';

import FirstLoader from '../FirstLoader/FirstLoader';

const LoadableP2pTransferWizard = Loadable({
  loader: () => import(/* webpackChunkName: "P2pTransfer" */ './P2pTransferWizard'),
  modules: ['./P2pTransfer'],
  loading: () => <FirstLoader />
});

export default LoadableP2pTransferWizard;
